"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFirefox = void 0;
/**
 * Detects if the browser is firefox and return true if so
 *
 */
function isFirefox() {
    // keepAlive is not supported in Firefox or Firefox for Android
    return (!!navigator.userAgent &&
        navigator.userAgent.toLowerCase().includes('firefox'));
}
exports.isFirefox = isFirefox;
//# sourceMappingURL=Browser.js.map